/**
 * DOUGHNUT_CHART_CONFIG: a JSON object representing a schema used to drive doughnut charts for HighCharts.
 */
export const DOUGHNUT_CHART_CONFIG = {
	chart: {
		height: null,
		width: null,
		spacing: 0,
		marginTop: 5,
		style: {
			fontFamily: 'FortBook, Arial, sans-serif',
			color: null
		},
		type: 'pie'
	},
	plotOptions: {
		pie: {
			dataLabels: {
				enabled: false
			},
			innerSize: '80%',
			startAngle: 0,
			endAngle: 360,
			center: ['50%', '50%']
		}
	},
	tooltip: {
		backgroundColor: '#f9f9f9',
		borderColor: '#a5a5a5',
		borderRadius: 0,
		shadow: false,
		useHTML: true,
		style: {
			fontFamily: 'FortBook, Arial, sans-serif'
		}
	},
	colors: null,
	responsive: {
		rules: [
			{
				condition: { maxWidth: 140 },
				chartOptions: {
					chart: {
						height: null,
						spacingBottom: 60
					},
					plotOptions: {
						pie: {
							innerSize: '55%'
						}
					},
					title: {
						widthAdjust: -20,
						style: {
							fontSize: '12px',
							lineHeight: '16px',
							color: '#000000',
							fontFamily: 'FortBold, Arial, sans-serif'
						},
						align: 'center',
						verticalAlign: 'middle',
						y: 80
					}
				}
			},
			{
				condition: { maxWidth: 90 },
				chartOptions: {
					chart: {
						height: null,
						spacingBottom: 90
					},
					plotOptions: {
						pie: {
							innerSize: '0%'
						}
					},
					title: {
						widthAdjust: -10
					}
				}
			}
		]
	},
	title: {
		text: null, // this.hideTitle ? '' : this.seriesTitle,
		widthAdjust: null,
		style: {
			color: '#000000',
			fontFamily: 'FortBold, Arial, sans-serif'
		},
		align: 'center',
		y: 15,
		verticalAlign: 'middle'
	},
	series: null
};
